import { Vms } from '_lib/api';
import { Ivim } from '_store/ivim/ivimsTypes';

export type VmsStatusAlertKind = 'fault' | 'recovered';

export interface VmsStatusAlert {
  id: string;
  vmsId: string;
  kind: VmsStatusAlertKind;
  name: string;
  createdAt: string;
}

export interface PmvReducerState {
  loading: boolean;
  ivimsByVmsId: Record<string, Ivim[]>;
  ivimsLoadingByVmsId: Record<string, boolean>;
  statusAlerts: VmsStatusAlert[];
}

export const isVmsEnrolled = (vms: Vms): boolean => vms.enrichment?.enrolled === true;

export const vmsEnrichmentName = (vms: Vms): string => vms.enrichment?.name?.trim() ?? '';

/** User-facing label: enrichment name for enrolled items; never description as title when enrolled. */
export const vmsDisplayName = (vms: Vms): string => {
  const enrichmentName = vmsEnrichmentName(vms);
  if (enrichmentName) return enrichmentName;
  if (isVmsEnrolled(vms)) return vms.id;
  return vms.description || vms.id;
};
